<template>
    <v-dialog max-width="800px" v-model="isOpenFilterDialog" persistent>
        <v-form>
            <v-card>
                <v-card-title primary-title>
                    <div
                        v-if="$vuetify.breakpoint.xs"
                        class="primary--text text-overline ml-2"
                    >
                        <v-icon left> mdi-magnify </v-icon>
                        Filtros de búsqueda
                    </div>
                    <div
                        v-else
                        class="font-weight-light primary--text text-h4 ml-2"
                    >
                        <v-icon large left> mdi-magnify </v-icon>
                        Filtros de búsqueda
                    </div>
                </v-card-title>
                <!-- <v-divider class="test"></v-divider> -->

                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card elevation="0" class="px-4">
                                <!-- <v-row>
                                    <v-col md="12" class="mt-md-1">
                                        <h4
                                            class="
                                                font-weight-light
                                                primary--text
                                            "
                                        >
                                            Tipo de comercial
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider> -->
                                <v-row>
                                    <v-col cols="12">
                                        <v-combobox
                                            :class="
                                                tmpselectedTipoComercial
                                                    ? 'mt-2'
                                                    : 'mt-2 mb-2'
                                            "
                                            v-model="tmpselectedTipoComercial"
                                            :items="tipoComercial"
                                            item-text="human"
                                            item-value="encoded"
                                            :return-object="false"
                                            clearable
                                            label="Tipo de comercial"
                                            prepend-icon="mdi-account-convert"
                                        >
                                            <template
                                                v-slot:selection="{ item }"
                                            >
                                                <v-chip
                                                    color="orange accent-3"
                                                    dark
                                                >
                                                    {{
                                                        item
                                                            .toLowerCase()
                                                            .replace(
                                                                /\w/,
                                                                (firstLetter) =>
                                                                    firstLetter.toUpperCase()
                                                            )
                                                    }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card elevation="0" class="px-4">
                                <!-- <v-row>
                                    <v-col md="12" class="mt-md-1">
                                        <h4
                                            class="
                                                font-weight-light
                                                primary--text
                                            "
                                        >
                                            Estado comercial
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider> -->
                                <v-row>
                                    <v-col cols="12">
                                        <v-combobox
                                            :class="
                                                tmpselectedStatusComercial
                                                    ? 'mt-2'
                                                    : 'mt-2 mb-2'
                                            "
                                            v-model="tmpselectedStatusComercial"
                                            :items="estadoComercial"
                                            item-text="human"
                                            item-value="encoded"
                                            :return-object="false"
                                            clearable
                                            label="Estado comercial"
                                            prepend-icon="mdi-account-convert"
                                        >
                                            <template
                                                v-slot:selection="{ item }"
                                            >
                                                <v-chip
                                                    color="orange accent-3"
                                                    dark
                                                >
                                                    {{
                                                        item
                                                            .toLowerCase()
                                                            .replace(
                                                                /\w/,
                                                                (firstLetter) =>
                                                                    firstLetter.toUpperCase()
                                                            )
                                                    }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn @click="filter()" depressed color="success" dark>
                        Filtrar
                    </v-btn>
                    <v-btn @click="closeFilterDialog()" text color="red">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ComercialesTableFilterDialog',
    data: () => ({
        menu: false,
        tmpselectedTipoComercial: null,
        tmpselectedStatusComercial: null,
    }),
    computed: {
        tipoComercial() {
            return JSON.parse(localStorage.getItem('opciones')).cuenta
                .tipoComercial;
        },
        estadoComercial() {
            return JSON.parse(localStorage.getItem('opciones')).cuenta.estado;
        },
        isOpenFilterDialog: {
            get() {
                return this.$store.state.objectivesReport.isOpenFilterDialog;
            },
            set(val) {
                this.$store.commit('objectivesReport/isOpenFilterDialog', val);
            },
        },
        // ...mapState('util', {
        // tipoComercial: (state) => state.opciones.cuenta.tipoComercial,
        // estadoComercial: (state) => state.opciones.cuenta.estado,
        // }),
    },
    methods: {
        closeFilterDialog() {
            this.$store.commit('objectivesReport/isOpenFilterDialog', false);
        },
        filter() {
            this.$store.commit(
                'objectivesReport/selectedTipoComercial',
                this.tmpselectedTipoComercial
            );
            this.$store.commit(
                'objectivesReport/selectedStatusComercial',
                this.tmpselectedStatusComercial
            );
            this.closeFilterDialog();
        },
    },
};
</script>
